
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <p className="text-gray-600 mb-2">ラジオパーソナリティ / 舞台女優 / MC</p>
          <h2 className="text-2xl font-bold text-gray-800 mb-6" style={{ fontFamily: '"Pacifico", serif' }}>
            安藤 紗織 | Saori Ando
          </h2>
          
          {/* Navigation Links */}
          <nav className="flex flex-wrap justify-center gap-6 mb-8">
            <button 
              onClick={() => scrollToSection('works')}
              className="text-gray-600 hover:text-pink-600 transition-colors"
            >
              実績
            </button>
            <button 
              onClick={() => scrollToSection('profile')}
              className="text-gray-600 hover:text-pink-600 transition-colors"
            >
              プロフィール
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-600 hover:text-pink-600 transition-colors"
            >
              サービス内容
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-600 hover:text-pink-600 transition-colors"
            >
              お問い合わせ
            </button>
          </nav>

          {/* Social Links */}
          <div className="flex justify-center space-x-6 mb-8">
            <a href="https://www.instagram.com/saori_ando_0707/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-600 transition-colors">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-instagram-line text-xl"></i>
              </div>
            </a>
            <a href="https://x.com/7saorin7" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-600 transition-colors">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-twitter-x-line text-xl"></i>
              </div>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © 2025 安藤紗織 (Saori Ando). All rights reserved. | 
            <a href="https://readdy.ai/?origin=logo" className="hover:text-pink-600 transition-colors ml-1">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
